const classTriggerForSearch = (el, val) => {
  if (val) {
    el.classList.add('on-overlay')
  } else {
    el.classList.remove('on-overlay')
  }
} 
export function createStore(parameters) {
  return {
    namespaced: true,
    state: {
      global_search: '',
      show_overlay: false,
      active_search: false,
    },
    actions: {
      trigger_search({ commit }, payload) {
        console.log(payload);
        commit('ACTIVATE', payload)
      },
      trigger_overlay({ commit }, payload) {
        let mobile_el = document.getElementById('header')
        // let desktop_el = document.getElementById('desktop-search')
        // let desktop = 1200
        // if (window.innerWidth < desktop) {
        // } else {
        //   classTriggerForSearch(desktop_el, payload)
        // }
        classTriggerForSearch(mobile_el, payload)
        commit('SET_OVERLAY', payload)
      },
    },
    mutations: {
      ACTIVATE(state, payload) { 
        state.active_search = payload
      },
      SET_SEARCH(state, payload) {
        state.global_search = payload
      },
      SET_OVERLAY(state, payload) {
        state.show_overlay = payload
        
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/js/shared/store/modules/search.js